// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3S75B","newExpiryDate":"styles_newExpiryDate__XrPpV","footer":"styles_footer__3LmIz"};